const UP = 'UP';
const DOWN = 'DOWN';
const LEFT = 'LEFT';
const RIGHT = 'RIGHT';
const CENTER = 'CENTER';

export const DIRECTIONS = {
    UP,
    DOWN,
    LEFT,
    RIGHT,
    CENTER,
}